import CodeVerifying from './CodeVerifying';

export default CodeVerifying;
